import SetupRmWakeupSmsModal from './setup-rm-wakeup-sms-modal.vue'
export default SetupRmWakeupSmsModal
